const DITypes = {
  JsonRpcDispatcher: Symbol('JsonRpcDispatcher'),
  AdapterFactory: Symbol('AdapterFactory'),
};

export default DITypes;
